import { render, staticRenderFns } from "./LeadInfoDisplay.vue?vue&type=template&id=64cdbc35"
import script from "./LeadInfoDisplay.vue?vue&type=script&lang=js"
export * from "./LeadInfoDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports